import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "isOpen", "renderExtraOptions", "onOpenChange"];
import { LikeLink, RouterLink } from 'academy-common-lib/components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MobileNestedMenu from 'academy-common-lib/components/Modals/FullScreenModal/MobileNestedMenu';
import PanelSection from 'academy-common-lib/components/Modals/FullScreenModal/PanelSection';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import AddToPlaylist from '../../savedItems/components/AddToPlaylist';
import CardMenuWatchLaterOption from '../../savedItems/components/CardMenuWatchLaterOption';
import ChangePlaylistThumbnail from '../../savedItems/components/ChangePlaylistThumbnail';
import CreatePlaylistLink from '../../savedItems/components/CreatePlaylistLink';
import StartPlaylistButton from '../../savedItems/components/StartPlaylistButton';
import { EditPlaylistButton } from '../../savedItems/components/EditPlaylistButton';
import { UploadPlaylistThumbnailButton } from '../../savedItems/components/UploadPlaylistThumbnailButton';
import { useUserOwnsPlaylist } from '../../savedItems/savedItemsQueries';
import { MobileSocialShareMenuOption } from '../../share/components/SocialShareMenuOption';
import { DuplicatePlaylistButton } from '../../savedItems/components/DuplicatePlaylistButton';
import { ArchivePlaylistButton } from '../../myPlaylists/components/ArchivePlaylistButton';
import { SavePlaylistButton } from '../../myPlaylists/components/SavePlaylistButton';
import { AssignPlaylistButton } from '../../playlistAssignments/components/AssignPlaylistButton';
import { PlaylistAssignmentsSearchProvider } from '../../playlistAssignments/components/PlaylistAssignmentsSearch';
import { UnAssignPlaylist, UnassignPlaylistHeader, UnassignPlaylistLoadMore } from '../../playlistAssignments/components/UnAssignPlaylist';
import { usePlaylistAssignmentsPortals } from '../../playlistAssignments/playlistAssignmentsQueries';
import { View } from 'foundations-components/components/View';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import CardMenuMyLearningOption from './CardMenuMyLearningOption';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { isShortCardModel, isTrackOrLessonCardModel } from 'academy-common-lib/features/cards/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MenuRow = ({
  children
}) => /*#__PURE__*/_jsx(TFlex, {
  paddingBlock: "300",
  paddingInline: "500",
  children: children
});
export const MenuButton = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    block: true,
    paddingBlock: "300",
    paddingInline: "500"
  }, props, {
    children: children
  }));
};
export const MenuLink = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(MenuRow, {
    children: /*#__PURE__*/_jsx(RouterLink, Object.assign({}, props, {
      children: children
    }))
  });
};
export const MenuLikeLink = ({
  children
}) => /*#__PURE__*/_jsx(MenuRow, {
  children: /*#__PURE__*/_jsx(LikeLink, {
    children: children
  })
});
export const MenuLabel = ({
  children,
  withChevron
}) => /*#__PURE__*/_jsxs(TFlex, {
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(Box, {
    grow: 1,
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      textAlign: "left",
      children: children
    })
  }), withChevron && /*#__PURE__*/_jsx(RightIcon, {
    color: "text-core-default"
  })]
});
const ShareButtonLabel = ({
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "academyCommon.common.share"
  })
}) => /*#__PURE__*/_jsx(MenuLabel, {
  withChevron: true,
  children: shareButtonLabel
});
const ShareButtonContents = ({
  item,
  parentPlaylist,
  parentTrack,
  onShare,
  shareButtonLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.common.share"
  })
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(PanelSection, {
    showBorders: false,
    title: shareButtonLabel
  }), /*#__PURE__*/_jsx(MobileSocialShareMenuOption, {
    item: item,
    onShare: onShare,
    parentPlaylist: parentPlaylist,
    parentTrack: parentTrack
  })]
});
const TrackLessonMenuOptions = ({
  item,
  parentPlaylist,
  parentTrack,
  onOpenChange,
  children,
  overviewType
}) => {
  const {
    id,
    type,
    language
  } = item;
  const closeModal = () => onOpenChange(false);
  const showIfMyLearning = overviewType === 'my-learning' || overviewType === 'in-progress-section';
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: id,
      contentType: type,
      language: language,
      visibility: item.visibility ? readUnhandledEnumCase(item.visibility) : undefined
    });
  };
  const onAddToNewPlaylistClick = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: id,
      contentType: type,
      language: language,
      visibility: item.visibility ? readUnhandledEnumCase(item.visibility) : undefined
    });
  };
  const shareButtonLabel = parentPlaylist || parentTrack ? undefined : item.type === 'TRACK' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.shareThis.shareTrack"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.shareThis.shareLesson"
  });
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        item: {
          id,
          type: type,
          language: language
        },
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(TFlex, {
              children: [/*#__PURE__*/_jsx(Box, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                item: {
                  id,
                  type: type,
                  language: language
                },
                render: (linkContent, openModal) => /*#__PURE__*/_jsx(Button, {
                  onClick: () => {
                    onAddToNewPlaylistClick();
                    openModal();
                  },
                  use: "link",
                  children: linkContent
                }),
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyCommon.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(MenuRow, {
            children: content
          })
        }, key)
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(MenuLabel, {
        withChevron: true,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "academyCommon.cardMenu.addToPlaylist"
        })
      })
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      item: {
        id,
        type: type,
        language: language
      },
      render: (linkContent, openModal) => /*#__PURE__*/_jsx(MenuButton, {
        onClick: () => {
          onAddToNewPlaylistClick();
          openModal();
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(MenuLabel, {
          children: linkContent
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.cardMenu.addToNewPlaylist"
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: item,
        onShare: closeModal,
        parentPlaylist: parentPlaylist,
        parentTrack: parentTrack,
        shareButtonLabel: shareButtonLabel
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: shareButtonLabel
      })
    }), showIfMyLearning && /*#__PURE__*/_jsx(CardMenuMyLearningOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), children]
  });
};
const PlaylistMenuOptions = ({
  item,
  onOpenChange,
  children,
  overviewType
}) => {
  const {
    id: playlistId
  } = item;
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  const {
    playlistAssignmentsPortals
  } = usePlaylistAssignmentsPortals({
    playlistId
  });
  const shouldShowUnassignButton = !playlistAssignmentsPortals || playlistAssignmentsPortals.length > 0;
  const closeModal = () => onOpenChange(false);
  const showIfMyLearning = overviewType === 'my-learning' || overviewType === 'in-progress-section';
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    children: [/*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(StartPlaylistButton, {
        appearsIn: "playlist",
        block: true,
        playlistId: playlistId,
        showLoader: true,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(EditPlaylistButton, {
        block: true,
        playlistId: playlistId,
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
          onItemClick: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(TFlex, {
                children: /*#__PURE__*/_jsx(Box, {
                  grow: 1,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.cardMenu.playlistItems"
                  })
                })
              })
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(MenuRow, {
              children: content
            })
          }, key)
        }), /*#__PURE__*/_jsx(View, {
          as: "div",
          margin: "400",
          children: /*#__PURE__*/_jsx(UploadPlaylistThumbnailButton, {
            onImageUpload: closeModal,
            playlistId: playlistId,
            use: "tertiary"
          })
        })]
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(MenuLabel, {
        withChevron: true,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "academyCommon.cardMenu.changeThumbnail"
        })
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: item,
        onShare: closeModal,
        shareButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.shareThis.sharePlaylist"
        })
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.shareThis.sharePlaylist"
        })
      })
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId,
        render: onClick => /*#__PURE__*/_jsx(Button, {
          block: true,
          onClick: onClick,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(View, {
            inlineSize: "100%",
            textAlign: "start",
            children: /*#__PURE__*/_jsx(Text, {
              color: "text-core-default",
              textDecoration: "none",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.playlistAssignments.assignPlaylist"
              })
            })
          })
        })
      })
    }), shouldShowUnassignButton && /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(PlaylistAssignmentsSearchProvider, {
        children: /*#__PURE__*/_jsx(UnAssignPlaylist, {
          loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
            children: /*#__PURE__*/_jsx(UnassignPlaylistLoadMore, {})
          }),
          onUnassigned: closeModal,
          playlistId: playlistId,
          renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PanelSection, {
              showBorders: false,
              title: /*#__PURE__*/_jsx(UnassignPlaylistHeader, {})
            }), content]
          }),
          renderRow: (content, key) => /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(MenuRow, {
              children: content
            })
          }, key)
        })
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(MenuLabel, {
        withChevron: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyCommon.playlistAssignments.unassignPlaylist"
        })
      })
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(DuplicatePlaylistButton, {
        block: true,
        playlistId: playlistId,
        use: "unstyled"
      })
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(SavePlaylistButton, {
        block: true,
        onClick: closeModal,
        playlistId: playlistId
      })
    }), /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsx(ArchivePlaylistButton, {
        block: true,
        onClick: closeModal,
        playlistId: playlistId,
        showTooltip: true
      })
    }), showIfMyLearning && /*#__PURE__*/_jsx(CardMenuMyLearningOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), children]
  });
};
const ShortMenuOptions = ({
  item,
  parentPlaylist,
  onOpenChange,
  children,
  overviewType
}) => {
  const {
    id: shortId,
    type,
    language
  } = item;
  const closeModal = () => onOpenChange(false);
  const showIfMyLearning = overviewType === 'my-learning' || overviewType === 'in-progress-section';
  const visibility = item.visibility ? readUnhandledEnumCase(item.visibility) : undefined;
  const onAddToPlaylistClick = () => {
    closeModal();
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'add-to-playlist',
      location: 'card-menu',
      itemId: shortId,
      visibility
    });
  };
  const onAddToNewPlaylistClick = () => {
    closeModal();
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'add-to-new-playlist',
      location: 'card-menu',
      itemId: shortId,
      visibility
    });
  };
  const shareButtonLabel = parentPlaylist ? undefined : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.shareThis.shareShort"
  });
  return /*#__PURE__*/_jsxs(MobileNestedMenu, {
    indented: false,
    open: true,
    setIsOpen: onOpenChange,
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(AddToPlaylist, {
        item: {
          id: shortId,
          type: type,
          language: language
        },
        loadMode: "button",
        loadMoreButton: /*#__PURE__*/_jsx(MenuLikeLink, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.cardMenu.loadMorePlaylists"
          })
        }),
        onPlaylistClick: onAddToPlaylistClick,
        renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PanelSection, {
            showBorders: false,
            title: /*#__PURE__*/_jsxs(TFlex, {
              children: [/*#__PURE__*/_jsx(Box, {
                grow: 1,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyNav.heading.myPlaylists"
                })
              }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
                item: {
                  id: shortId,
                  type: type,
                  language: language
                },
                render: (linkContent, openModal) => /*#__PURE__*/_jsx(Button, {
                  onClick: () => {
                    onAddToNewPlaylistClick();
                    openModal();
                  },
                  use: "link",
                  children: linkContent
                }),
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyCommon.cardMenu.addToNewPlaylist"
                })
              })]
            })
          }), content]
        }),
        renderRow: (content, key) => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(MenuRow, {
            children: content
          })
        }, key)
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(MenuLabel, {
        withChevron: true,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "academyCommon.cardMenu.addToPlaylist"
        })
      })
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      item: {
        id: shortId,
        type: type,
        language: language
      },
      render: (linkContent, openModal) => /*#__PURE__*/_jsx(MenuButton, {
        onClick: () => {
          onAddToNewPlaylistClick();
          openModal();
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(MenuLabel, {
          children: linkContent
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.cardMenu.addToNewPlaylist"
      })
    }), /*#__PURE__*/_jsx(MenuButton
    // @ts-expect-error Untyped
    , {
      subpage: /*#__PURE__*/_jsx(ShareButtonContents, {
        item: item,
        onShare: closeModal,
        parentPlaylist: parentPlaylist,
        shareButtonLabel: shareButtonLabel
      }),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(ShareButtonLabel, {
        shareButtonLabel: shareButtonLabel
      })
    }), showIfMyLearning && /*#__PURE__*/_jsx(CardMenuMyLearningOption, {
      item: item,
      onClick: closeModal,
      render: content => /*#__PURE__*/_jsx(MenuRow, {
        children: content
      })
    }), children]
  });
};
const MobileCardMenu = _ref3 => {
  let {
      children,
      isOpen,
      renderExtraOptions,
      onOpenChange
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const {
    item
  } = props;
  const trackLessonItem = isTrackOrLessonCardModel(item) ? item : null;
  const shortItem = isShortCardModel(item) ? item : null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: [(item.type === 'PLAYLIST' || item.type === 'LEARNING_PATH') && /*#__PURE__*/_jsx(PlaylistMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), trackLessonItem && /*#__PURE__*/_jsx(TrackLessonMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        item: trackLessonItem,
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      })), shortItem && /*#__PURE__*/_jsx(ShortMenuOptions, Object.assign({
        onOpenChange: onOpenChange
      }, props, {
        item: shortItem,
        children: renderExtraOptions && renderExtraOptions(onOpenChange)
      }))]
    })]
  });
};
export default MobileCardMenu;